export const seoCopyVisibilityController = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        LAYOUT_MODAL_CLOSE: {
          target: 'showSeoCopy',
        },
        LAYOUT_CHANGE_END: {
          target: 'hideSeoCopy',
          cond: 'isGameDetailsPage',
        },
      },
    },
    showSeoCopy: {
      entry: [
        {
          type: 'batchLayoutOperations',
          data: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.copy.properties',
                value: {
                  visible: true,
                },
              },
            },
          ],
        },
      ],
      always: 'idle',
    },
    hideSeoCopy: {
      entry: [
        {
          type: 'batchLayoutOperations',
          data: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.copy.properties',
                value: {
                  visible: false,
                },
              },
            },
          ],
        },
      ],
      always: 'idle',
    },
  },
};
